const homeMenuItem = {
  icon: 'Home',
  key: 'dashboard',
  title: 'DASHBOARD',
  url: '/',
};
const auctionsMenuItem = {
  icon: 'Hummer2',
  key: 'auctions',
  title: 'AUCTIONS',
};
const partiesMenuItem = {
  icon: 'Group',
  key: 'parties',
  title: 'PARTIES',
};
const garagesMenuItem = {
  icon: 'Tools',
  key: 'garages',
  title: 'GARAGES',
  subItems: [
    { key: 'all-garages', title: 'LIST', url: '/all-garages' },
    { key: 'new-garage', title: 'ADDITION', url: '/new-garage' },
  ],
};
const reportsMenuItems = {
  icon: 'PieChart',
  key: 'reports',
  title: 'REPORTS',
  url: '/reports',
};

const menuItemsOperator = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'pending-approval-auctions',
        title: 'PENDING_APPROVAL',
        url: '/auctions/pending-approval',
      },
      {
        key: 'for-selection-auctions',
        title: 'FOR_SELECTION',
        url: '/auctions/for-selection',
      },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'for-dispatch-auctions',
        title: 'FOR_DISPATCH',
        url: '/auctions/for-dispatch',
      },
      {
        key: 'dispatch-problem-auctions',
        title: 'DISPATCH_PROBLEM',
        url: '/auctions/dispatch-problem',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
    ],
  },
  {
    ...partiesMenuItem,
    subItems: [
      { key: 'all-parties', title: 'LIST', url: '/all-parties' },
      { key: 'new-party', title: 'CREATE_NEW', url: '/parties/new' },
    ],
  },
  garagesMenuItem,
  reportsMenuItems,
  //  { key: 'settings', title: 'SETTINGS', iconClassName: 'icon-settings', url: '/settings' },
];

const menuItemsAdminInsurance = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'pending-approval-auctions',
        title: 'PENDING_APPROVAL',
        url: '/auctions/pending-approval',
      },
      {
        key: 'for-selection-auctions',
        title: 'FOR_SELECTION',
        url: '/auctions/for-selection',
      },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'for-dispatch-auctions',
        title: 'FOR_DISPATCH',
        url: '/auctions/for-dispatch',
      },
      {
        key: 'dispatch-problem-auctions',
        title: 'DISPATCH_PROBLEM',
        url: '/auctions/dispatch-problem',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
    ],
  },
  // {
  //   ...partiesMenuItem,
  //   subItems: [
  //     { key: 'all-parties', title: 'LIST', url: '/all-parties' },
  //     { key: 'new-party', title: 'CREATE_NEW', url: '/parties/new' },
  //   ],
  // },
  // garagesMenuItem,
  // reportsMenuItems,
  //  { key: 'settings', title: 'SETTINGS', iconClassName: 'icon-settings', url: '/settings' },
];

const menuItemsInsurance = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'pending-approval-auctions',
        title: 'PENDING_APPROVAL',
        url: '/auctions/pending-approval',
      },
      {
        key: 'for-selection-auctions',
        title: 'FOR_SELECTION',
        url: '/auctions/for-selection',
      },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'for-dispatch-auctions',
        title: 'FOR_DISPATCH',
        url: '/auctions/for-dispatch',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
      {
        key: 'rejected-auctions',
        title: 'REJECTED_PL_FEM',
        url: '/auctions/rejected',
      },
      {
        key: 'dispatch-problem-auctions',
        title: 'DISPATCH_PROBLEM',
        url: '/auctions/dispatch-problem',
      },
      { key: 'new-auction', title: 'CREATE_NEW_FEM', url: '/auctions/new' },
    ],
  },
  garagesMenuItem,
  reportsMenuItems,
];

const menuItemsExpert = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'for-selection-auctions',
        title: 'FOR_SELECTION',
        url: '/auctions/for-selection',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
      { key: 'new-auction', title: 'CREATE_NEW_FEM', url: '/auctions/new' },
    ],
  },
  reportsMenuItems,
];

const menuItemsMerchant = [
  homeMenuItem,
  {
    ...auctionsMenuItem,
    subItems: [
      { key: 'all-auctions', title: 'CURRENT', url: '/auctions' },
      {
        key: 'participate-to',
        title: 'PARTICIPATE_TO',
        url: '/auctions/participate-to',
      },
      {
        key: 'merchant-summary',
        title: 'OFFER_STATUS',
        url: '/auctions/merchant-summary',
      },
      {
        key: 'for-acceptance-auctions',
        title: 'FOR_ACCEPTANCE',
        url: '/auctions/for-acceptance',
      },
      {
        key: 'for-dispatch-auctions',
        title: 'FOR_DISPATCH',
        url: '/auctions/for-dispatch',
      },
      {
        key: 'dispatch-problem-auctions',
        title: 'DISPATCH_PROBLEM',
        url: '/auctions/dispatch-problem',
      },
      {
        key: 'completed-auctions',
        title: 'COMPLETED_PL_FEM',
        url: '/auctions/completed',
      },
      { key: 'lost-auctions', title: 'FINISHED', url: '/auctions/lost' },
    ],
  },
  reportsMenuItems,
];

export {
  menuItemsExpert,
  menuItemsInsurance,
  menuItemsMerchant,
  menuItemsOperator,
  menuItemsAdminInsurance,
};
